/**
 * 関連事例スライダー (modely/slider-content) のナビゲーション
 *
 * 旧 Concrete の Swiper.js ベース実装の再現:
 *   - メインスライドは横スクロール (scroll-snap) で指で送れる。左右 chevron とサムネイルでも送れる
 *   - 右下に「2／3」の枚数表示。自動再生は無し (動画埋め込みもありえるので)
 *   - 2026-10-27 まではフェード式で 1 枚ずつしか送れず、PostHog レビューで「次へ」の連打が見つかった
 *
 * ライトボックスは lightbox.js (popup-image-list で使われているもの) を再利用するため、
 * .bt_slider-content__zoom a に data-gallery / data-index を持たせている。
 */

function initOne(root) {
  const list = root.querySelector(".bt_slider-content__slides");
  const slides = root.querySelectorAll(".bt_slider-content__slide");
  if (!list || slides.length < 2) return;
  root.classList.add("is-swipe");

  const thumbs = root.querySelectorAll(".bt_slider-content__thumb");
  const count = slides.length;

  const counter = document.createElement("span");
  counter.className = "bt_slider-content__counter";
  const viewport = root.querySelector(".bt_slider-content__viewport") || root;
  viewport.appendChild(counter);

  let current = -1;
  const update = (idx) => {
    if (idx === current) return;
    current = idx;
    slides.forEach((s, i) => s.classList.toggle("is-active", i === idx));
    thumbs.forEach((t, i) => t.classList.toggle("is-active", i === idx));
    counter.textContent = `${idx + 1}／${count}`;
  };

  // 自分で動かしている間 (ボタン・サムネ) は、途中の位置から枚数を出さない (表示が行き来するため)
  let programmatic = false;
  let programmaticTarget = 0;
  const goTo = (idx) => {
    const next = (idx + count) % count;
    programmaticTarget = slides[next].offsetLeft;
    programmatic = Math.abs(list.scrollLeft - programmaticTarget) >= 2;
    list.scrollTo({ left: programmaticTarget, behavior: "smooth" });
    update(next);
  };
  const indexFromPosition = () => {
    const width = list.clientWidth || 1;
    return Math.max(0, Math.min(count - 1, Math.round(list.scrollLeft / width)));
  };

  let raf = 0;
  let settleTimer = 0;
  list.addEventListener("scroll", () => {
    window.cancelAnimationFrame(raf);
    window.clearTimeout(settleTimer);
    raf = window.requestAnimationFrame(() => {
      if (programmatic) {
        if (Math.abs(list.scrollLeft - programmaticTarget) < 2) {
          programmatic = false;
          update(indexFromPosition());
        }
        return;
      }
      update(indexFromPosition());
    });
    // スクロールが止まったのに目標に着いていなければ、途中で指に奪われたと見なす
    settleTimer = window.setTimeout(() => {
      if (!programmatic) return;
      programmatic = false;
      update(indexFromPosition());
    }, 200);
  }, { passive: true });

  const prev = root.querySelector("[data-slider-content-prev]");
  const next = root.querySelector("[data-slider-content-next]");
  if (prev) prev.addEventListener("click", () => goTo(current - 1));
  if (next) next.addEventListener("click", () => goTo(current + 1));

  thumbs.forEach((t) => {
    const btn = t.querySelector("[data-slider-content-thumb]");
    if (!btn) return;
    btn.addEventListener("click", () => {
      const idx = parseInt(btn.dataset.sliderContentThumb, 10);
      if (!Number.isNaN(idx)) goTo(idx);
    });
  });

  update(0);
}

export function initSliderContent() {
  document.querySelectorAll("[data-slider-content]").forEach(initOne);
}
